import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';


const TicketDetail = loadable(() => pMinDelay(import('./TicketDetail'), 300), {
  fallback: <Loading/>
});

const AsyncTicketDetail = props => {
  const pageConfig = {
    headerType: 'none',
    footerType: 'none',
    helmet: {
      bodyAttributes: {
        class: `${props.userAgent.device?.type} hide-betslip hide-sticky-navigation ticket-detail-body`
      }
    }
  };


  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <TicketDetail { ...props } />
    </ApplicationLayout>
  );
};

AsyncTicketDetail.propTypes = {
  userAgent: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
};

export default AsyncTicketDetail;
